const AbstractDialog = require("common/AbstractDialog");
const Utils = require("common/Utils");

function DynAppsLaunchDialog() {
    AbstractDialog.call(this);

    const self = this;
    let firewallRule;
    let origState;

    const $content = this.getContent();
    $content.attr("id", "dynAppsLaunchDialog")
        .append($(require("html!./launch_dialog_content.html")));

    const $stateInput = $content.find("select#stateInput");
    const $continueButton = $content.find("#continueButton");
    let noPermissions = false;

    this.setTitle($.t("common::dynapps.launchDialog.title"));

    $content.find("a:not(#continueButton)").on("click", function() {
        self.publishEvent("DynAppsController", "cancel-launch-dialog");
    });

    this.initialize = function(fwRule) {
        firewallRule = fwRule;
        $stateInput.show();
        noPermissions = false;
        $stateInput.find("option").remove();
        $content.find(".timeRemaining").remove();
        $content.find(".noPermissions").remove();

        if (!fwRule.hasOwnProperty("allow_enable") || fwRule.allow_enable === true) {
            $stateInput.append($("<option>", {value : "Enabled", "data-i18n" : "common::dynapps.enabled.option"}));
        }

        if (!fwRule.hasOwnProperty("allow_time_enable") || fwRule.allow_time_enable === true) {
            $stateInput.append($("<option>", {value : "EnabledWithTime", "data-i18n" : "common::dynapps.enabledWithTime.option"}));
        }

        if (!fwRule.hasOwnProperty("allow_disable") || fwRule.allow_disable === true) {
            $stateInput.append($("<option>", {value : "Disabled", "data-i18n" : "common::dynapps.disabled.option"}));
        }
        $stateInput.i18n();

        if (fwRule.state === "Enabled" && fwRule.time_left > 0) {
            origState = "EnabledWithTime";
            setTimeRemaining(fwRule.time_left);
        } else {
            origState = fwRule.state;
        }

        if ($stateInput.find("option").length > 0) {
            if ($stateInput.find("option[value='" + origState + "']").length === 1) {
                $stateInput.val(origState);
            } else {
                // User is not allowed to select the rule's current state
                if ($stateInput.find("option[value='Disabled']").length === 1) {
                    $stateInput.val("Disabled");
                } else if ($stateInput.find("option[value='Enabled']").length === 1) {
                    $stateInput.val("Enabled");
                } else {
                    $stateInput.val("EnabledWithTime");
                }
            }
        } else {
            // User does not have the right to change the rule's state
            noPermissions = true;
            $($content.find(".dynAppsLaunchDialog")[0]).prepend($("<span>", {class : "noPermissions", text : $.t("common::dynapps.noPermissions")}));
        }
        $stateInput.selectmenu("refresh");
    };

    function setTimeRemaining(seconds) {
        const text = Utils.formatTimeAsString(Utils.splitTime(seconds), false, false);
        const fullText = $.t("common::dynapps.remaining", {remaining : text});
        $($content.find(".dynAppsLaunchDialog")[0]).prepend($("<span>", {class : "timeRemaining", text : fullText}));
    }

    function submit() {
        if (noPermissions) {
            self.publishEvent("DynAppsController", "cancel-launch-dialog");
            $content.popup("close");
            return;
        }

        const selectedState = $stateInput.val();

        if (selectedState === "EnabledWithTime") {
            $content.popup("close");
            self.publishEvent("DynAppsController", "show-time-selector", {dynapp : firewallRule, time : Utils.splitTime(firewallRule.time_left)});
            return;
        }

        if (selectedState === origState) {
            self.publishEvent("DynAppsController", "cancel-launch-dialog");
        } else {
            self.publishEvent("DynAppsController", "changeDynAppState", {
                dynapp : firewallRule,
                newState : selectedState
            });
        }
        $content.popup("close");
    }

    $continueButton.on("click", submit);

    this.show = function() {
        this.setEnabled(true);
        $stateInput.trigger("focus");
    };

    this.setEnabled = function(val) {
        Utils.setElementEnabled($continueButton, val);
        Utils.setElementEnabled($stateInput, val);
        Utils.setElementEnabled($content.find("a.ui-icon-mobile-close"), val);

        if (noPermissions) {
            $stateInput.parent().hide();
        } else {
            $stateInput.parent().show();
        }
    };
}

Utils.inherits(DynAppsLaunchDialog, AbstractDialog);

module.exports = DynAppsLaunchDialog;


//////////////////
// WEBPACK FOOTER
// ./dyn_apps/DynAppsLaunchDialog.js
// module id = 116
// module chunks = 0